var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplayimage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 49,
    viewBox: "0 0 155 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 49,
    rx: 10,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7602 26.4088C75.1908 26.4088 73.0967 28.3578 73.0967 31.0421C73.0967 33.71 75.1908 35.6753 77.7602 35.6753C80.3306 35.6753 82.4248 33.71 82.4248 31.0421C82.4237 28.3578 80.3296 26.4088 77.7602 26.4088ZM77.7602 33.8516C76.3521 33.8516 75.1384 32.6936 75.1384 31.0432C75.1384 29.3752 76.3531 28.2346 77.7602 28.2346C79.1683 28.2346 80.382 29.3752 80.382 31.0432C80.382 32.6925 79.1683 33.8516 77.7602 33.8516ZM67.5853 26.4088C65.016 26.4088 62.9218 28.3578 62.9218 31.0421C62.9218 33.71 65.016 35.6753 67.5853 35.6753C70.1559 35.6753 72.25 33.71 72.25 31.0421C72.25 28.3578 70.1559 26.4088 67.5853 26.4088ZM67.5853 33.8516C66.1772 33.8516 64.9635 32.6936 64.9635 31.0432C64.9635 29.3752 66.1783 28.2346 67.5853 28.2346C68.9935 28.2346 70.2072 29.3752 70.2072 31.0432C70.2083 32.6925 68.9935 33.8516 67.5853 33.8516ZM55.4836 27.8316V29.7969H60.2006C60.0597 30.9026 59.6905 31.7099 59.1268 32.2709C58.4408 32.9551 57.3669 33.71 55.4836 33.71C52.5799 33.71 50.3098 31.3754 50.3098 28.4798C50.3098 25.5841 52.5799 23.2495 55.4836 23.2495C57.05 23.2495 58.1938 23.8639 59.0382 24.6538L60.429 23.2669C59.2491 22.1438 57.6836 21.2842 55.4836 21.2842C51.5061 21.2842 48.1621 24.5132 48.1621 28.4798C48.1621 32.4463 51.5061 35.6753 55.4836 35.6753C57.6301 35.6753 59.2502 34.9727 60.5164 33.6567C61.8185 32.3581 62.2237 30.5322 62.2237 29.0582C62.2237 28.6029 62.1888 28.1813 62.1178 27.8305H55.4836V27.8316ZM104.979 29.3578C104.592 28.3229 103.413 26.4088 101.002 26.4088C98.6084 26.4088 96.6189 28.2869 96.6189 31.0421C96.6189 33.6392 98.5902 35.6753 101.23 35.6753C103.359 35.6753 104.592 34.3767 105.103 33.6218L103.518 32.5683C102.99 33.3407 102.269 33.8495 101.23 33.8495C100.192 33.8495 99.4526 33.3756 98.9769 32.4452L105.19 29.883L104.979 29.3578ZM98.643 30.9026C98.5902 29.1116 100.034 28.1998 101.073 28.1998C101.882 28.1998 102.568 28.6039 102.797 29.1824L98.643 30.9026ZM93.5923 35.3954H95.6337V21.7766H93.5923V35.3954ZM90.2474 27.4448H90.1773C89.7198 26.9001 88.8392 26.4088 87.732 26.4088C85.4082 26.4088 83.2791 28.4449 83.2791 31.0606C83.2791 33.6577 85.4082 35.6764 87.732 35.6764C88.8409 35.6764 89.7198 35.1851 90.1773 34.6241H90.2474V35.2908C90.2474 37.0632 89.2976 38.011 87.7666 38.011C86.5167 38.011 85.7425 37.1166 85.4257 36.3616L83.6483 37.0992C84.1585 38.3269 85.5131 39.8369 87.7666 39.8369C90.16 39.8369 92.1841 38.4326 92.1841 35.0097V26.6909H90.2491V27.4448H90.2474ZM87.9076 33.8516C86.4994 33.8516 85.3208 32.675 85.3208 31.0606C85.3208 29.4275 86.4994 28.2346 87.9076 28.2346C89.2976 28.2346 90.3884 29.4275 90.3884 31.0606C90.3884 32.675 89.2976 33.8516 87.9076 33.8516ZM114.542 21.7766H109.658V35.3954H111.695V30.2359H114.541C116.8 30.2359 119.022 28.605 119.022 26.0068C119.022 23.4086 116.801 21.7766 114.542 21.7766ZM114.595 28.3403H111.695V23.6722H114.595C116.118 23.6722 116.983 24.9305 116.983 26.0068C116.983 27.0613 116.118 28.3403 114.595 28.3403ZM127.192 26.3848C125.716 26.3848 124.188 27.0331 123.556 28.4699L125.365 29.2227C125.751 28.4699 126.472 28.2238 127.227 28.2238C128.281 28.2238 129.353 28.8546 129.37 29.9755V30.116C129.002 29.9058 128.21 29.591 127.245 29.591C125.295 29.591 123.309 30.6597 123.309 32.6566C123.309 34.4791 124.908 35.6525 126.7 35.6525C128.069 35.6525 128.825 35.0391 129.299 34.3201H129.369V35.3714H131.338V30.1498C131.339 27.7335 129.528 26.3848 127.192 26.3848ZM126.945 33.8484C126.279 33.8484 125.347 33.515 125.347 32.6914C125.347 31.6402 126.508 31.237 127.509 31.237C128.404 31.237 128.827 31.4299 129.37 31.6924C129.212 32.9551 128.123 33.8484 126.945 33.8484ZM138.506 26.6822L136.169 32.5868H136.099L133.675 26.6822H131.479L135.116 34.9345L133.042 39.5253H135.168L140.773 26.6822H138.506ZM120.148 35.3954H122.185V21.7766H120.148V35.3954Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1285 13.8713C55.1285 14.7842 54.8576 15.5109 54.3147 16.0535C53.6986 16.6984 52.8946 17.0208 51.907 17.0208C50.9609 17.0208 50.1558 16.694 49.4949 16.0404C48.8329 15.3856 48.502 14.5751 48.502 13.6077C48.502 12.6392 48.8329 11.8287 49.4949 11.175C50.1558 10.5203 50.9609 10.1935 51.907 10.1935C52.3767 10.1935 52.8257 10.285 53.2518 10.4669C53.6789 10.6499 54.0209 10.8929 54.2764 11.1968L53.7007 11.772C53.267 11.2545 52.6695 10.9964 51.9059 10.9964C51.2155 10.9964 50.619 11.2383 50.1154 11.722C49.6119 12.2057 49.3606 12.8342 49.3606 13.6066C49.3606 14.379 49.6119 15.0076 50.1154 15.4913C50.619 15.975 51.2155 16.2168 51.9059 16.2168C52.6378 16.2168 53.2485 15.9739 53.7368 15.487C54.0536 15.1699 54.2371 14.7287 54.2863 14.1633H51.9059V13.3779H55.0815C55.1144 13.5489 55.1285 13.7134 55.1285 13.8713Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1647 11.1418H57.1802V13.2139H59.8719V13.9993H57.1802V16.0713H60.1647V16.8753H56.3379V10.3389H60.1647V11.1418Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7161 16.8744H62.8739V11.1408H61.043V10.3379H65.547V11.1408H63.7161V16.8744Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8066 16.8753V10.3389H69.6489V16.8753H68.8066Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3822 16.8753H72.5399V11.1418H70.709V10.3389H75.2131V11.1418H73.3822V16.8753Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7399 16.0297C83.0955 16.6898 82.2947 17.0199 81.3366 17.0199C80.3786 17.0199 79.5779 16.6898 78.9345 16.0297C78.2899 15.3695 77.9688 14.5612 77.9688 13.6058C77.9688 12.6503 78.2899 11.842 78.9345 11.1818C79.5779 10.5216 80.3786 10.1904 81.3366 10.1904C82.2892 10.1904 83.0889 10.5227 83.7356 11.1861C84.3823 11.8496 84.7056 12.6558 84.7056 13.6058C84.7056 14.5612 84.3834 15.3695 83.7399 16.0297ZM79.556 15.4817C80.0411 15.972 80.6343 16.216 81.3366 16.216C82.0391 16.216 82.6333 15.9708 83.1173 15.4817C83.6023 14.9915 83.846 14.3661 83.846 13.6058C83.846 12.8453 83.6023 12.22 83.1173 11.7298C82.6333 11.2396 82.0391 10.9955 81.3366 10.9955C80.6343 10.9955 80.0411 11.2406 79.556 11.7298C79.0721 12.22 78.8284 12.8453 78.8284 13.6058C78.8284 14.3661 79.0721 14.9915 79.556 15.4817Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8887 16.8744V10.3379H86.9135L90.0984 15.4222H90.1347L90.0984 14.1628V10.3379H90.941V16.8744H90.0613L86.7288 11.5428H86.6925L86.7288 12.8021V16.8744H85.8887Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1285 13.8713C55.1285 14.7842 54.8576 15.5109 54.3147 16.0535C53.6986 16.6984 52.8946 17.0208 51.907 17.0208C50.9609 17.0208 50.1558 16.694 49.4949 16.0404C48.8329 15.3856 48.502 14.5751 48.502 13.6077C48.502 12.6392 48.8329 11.8287 49.4949 11.175C50.1558 10.5203 50.9609 10.1935 51.907 10.1935C52.3767 10.1935 52.8257 10.285 53.2518 10.4669C53.6789 10.6499 54.0209 10.8929 54.2764 11.1968L53.7007 11.772C53.267 11.2545 52.6695 10.9964 51.9059 10.9964C51.2155 10.9964 50.619 11.2383 50.1154 11.722C49.6119 12.2057 49.3606 12.8342 49.3606 13.6066C49.3606 14.379 49.6119 15.0076 50.1154 15.4913C50.619 15.975 51.2155 16.2168 51.9059 16.2168C52.6378 16.2168 53.2485 15.9739 53.7368 15.487C54.0536 15.1699 54.2371 14.7287 54.2863 14.1633H51.9059V13.3779H55.0815C55.1144 13.5489 55.1285 13.7134 55.1285 13.8713Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1647 11.1418H57.1802V13.2139H59.8719V13.9993H57.1802V16.0713H60.1647V16.8753H56.3379V10.3389H60.1647V11.1418Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7161 16.8744H62.8739V11.1408H61.043V10.3379H65.547V11.1408H63.7161V16.8744Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8066 16.8753V10.3389H69.6489V16.8753H68.8066Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3822 16.8753H72.5399V11.1418H70.709V10.3389H75.2131V11.1418H73.3822V16.8753Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7399 16.0297C83.0955 16.6898 82.2947 17.0199 81.3366 17.0199C80.3786 17.0199 79.5779 16.6898 78.9345 16.0297C78.2899 15.3695 77.9688 14.5612 77.9688 13.6058C77.9688 12.6503 78.2899 11.842 78.9345 11.1818C79.5779 10.5216 80.3786 10.1904 81.3366 10.1904C82.2892 10.1904 83.0889 10.5227 83.7356 11.1861C84.3823 11.8496 84.7056 12.6558 84.7056 13.6058C84.7056 14.5612 84.3834 15.3695 83.7399 16.0297ZM79.556 15.4817C80.0411 15.972 80.6343 16.216 81.3366 16.216C82.0391 16.216 82.6333 15.9708 83.1173 15.4817C83.6023 14.9915 83.846 14.3661 83.846 13.6058C83.846 12.8453 83.6023 12.22 83.1173 11.7298C82.6333 11.2396 82.0391 10.9955 81.3366 10.9955C80.6343 10.9955 80.0411 11.2406 79.556 11.7298C79.0721 12.22 78.8284 12.8453 78.8284 13.6058C78.8284 14.3661 79.0721 14.9915 79.556 15.4817Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8887 16.8744V10.3379H86.9135L90.0984 15.4222H90.1347L90.0984 14.1628V10.3379H90.941V16.8744H90.0613L86.7288 11.5428H86.6925L86.7288 12.8021V16.8744H85.8887Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1753_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7285 10.9245C14.4106 11.26 14.2227 11.7808 14.2227 12.4552V36.5485C14.2227 37.224 14.4106 37.7436 14.7285 38.0791L14.8093 38.1576L28.3433 24.6609V24.5018V24.3428L14.8093 10.845L14.7285 10.9245Z",
    fill: "url(#paint0_linear_1753_433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8543 29.1615L28.3438 24.6612V24.5021V24.3431L32.8554 19.8438L32.957 19.9016L38.3023 22.9301C39.8283 23.7951 39.8283 25.2102 38.3023 26.0763L32.957 29.1049L32.8543 29.1615Z",
    fill: "url(#paint1_linear_1753_433)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1753_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9546 29.1036L28.3403 24.502L14.7266 38.0793C15.2291 38.6109 16.0604 38.6763 16.9966 38.1468L32.9546 29.1036Z",
    fill: "url(#paint2_linear_1753_433)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.9546 19.9014L16.9966 10.8593C16.0604 10.3287 15.2291 10.3952 14.7266 10.9268L28.3414 24.5042L32.9546 19.9014Z",
    fill: "url(#paint3_linear_1753_433)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1753_433",
    x: 14.2227,
    y: 10.3125,
    width: 25.2241,
    height: 28.3808,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.180682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1753_433"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.180682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1753_433",
    result: "effect2_innerShadow_1753_433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1753_433",
    x: 14.7266,
    y: 24.3213,
    width: 18.228,
    height: 14.1913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.180682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1753_433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1753_433",
    x1: 27.1436,
    y1: 12.2002,
    x2: 8.86119,
    y2: 30.5332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1753_433",
    x1: 40.2888,
    y1: 24.5021,
    x2: 13.8567,
    y2: 24.5021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1753_433",
    x1: 30.4488,
    y1: 27.0009,
    x2: 5.65556,
    y2: 51.8628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1753_433",
    x1: 11.2979,
    y1: 2.90638,
    x2: 22.3688,
    y2: 14.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayimage);
export default __webpack_public_path__ + "static/media/googleplayimage.b6ed8ae5b0894c6d3d5b97c33e297be3.svg";
export { ForwardRef as ReactComponent };